<template>
  <v-dialog
    v-model="dialog"
    max-width="900px"
    max-height="90vh"
    content-class="my-custom-dialog"
    style="border-radius: 20px !important"
    scrollable
  >
    <v-card class="d-flex flex-column" style="height: 85vh">
      <v-card-title
        style="
          background-color: #1577da;
          font-weight: bold;
          color: white;
          flex-shrink: 0;
        "
      >
        <span class="text-h5" style="font-weight: bold">XML Prikaz</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="downloadXml" color="white" :disabled="!xmlContent">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn icon @click="dialog = false" color="white">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="flex-grow-1" style="overflow-y: auto; padding: 0">
        <div v-if="loading" class="text-center pa-8">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
          <div class="mt-4">Učitavam XML...</div>
        </div>

        <div v-else-if="error" class="text-center pa-8">
          <v-icon color="error" size="64">mdi-alert-circle</v-icon>
          <div class="mt-4 text-error">{{ error }}</div>
        </div>

        <div v-else-if="formattedXml" class="pa-4">
          <pre class="xml-content">{{ formattedXml }}</pre>
        </div>
      </v-card-text>

      <v-card-actions class="pr-10 pl-10" style="flex-shrink: 0">
        <v-row dense style="margin-top: 1rem; margin-bottom: 1rem">
          <v-btn
            class="btn successButton"
            @click="downloadXml"
            :disabled="!xmlContent"
          >
            <v-icon left>mdi-download</v-icon>
            Preuzmi XML
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="btn infoButton" @click="dialog = false">Zatvori</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { eracunApi } from '@/api/eracun'
import state from '@/state'

export default {
  name: 'XmlViewerDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    documentId: {
      type: [String, Number],
      default: null
    },
    documentName: {
      type: String,
      default: 'dokument'
    }
  },
  data () {
    return {
      loading: false,
      error: null,
      xmlContent: null,
      formattedXml: null
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (newVal) {
      if (newVal && this.documentId) {
        this.fetchXml()
      } else if (!newVal) {
        this.xmlContent = null
        this.formattedXml = null
        this.error = null
      }
    }
  },
  methods: {
    async fetchXml () {
      this.loading = true
      this.error = null

      try {
        const companyId = state.getCurrentCompany().id
        const response = await eracunApi.getDocumentXml(this.documentId, companyId)

        // Ako je response objekt s document propertijem
        if (response && response.document) {
          this.xmlContent = response.document
        } else if (typeof response === 'string') {
          // Ako je response direktno string
          this.xmlContent = response
        } else {
          throw new Error('Neočekivani format XML odgovora')
        }

        this.formattedXml = this.formatXml(this.xmlContent)
      } catch (error) {
        console.error('Error fetching XML:', error)
        this.error = 'Greška pri dohvaćanju XML-a'
        this.$emit('error', this.error)
      } finally {
        this.loading = false
      }
    },

    formatXml (xmlStr) {
      try {
        // Unescape HTML entities ako postoje
        const unescaped = xmlStr
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/&amp;/g, '&')

        // Format XML with indentation
        const formatted = this.prettifyXml(unescaped)
        return formatted
      } catch (error) {
        console.error('Error formatting XML:', error)
        return xmlStr // Return original if formatting fails
      }
    },

    prettifyXml (xmlStr) {
      let formatted = ''
      let indent = ''
      const tab = '  ' // Two spaces for indentation

      xmlStr.split(/>\s*</).forEach((node) => {
        if (node.match(/^\/\w/)) {
          indent = indent.substring(tab.length)
        }
        formatted += indent + '<' + node + '>\r\n'
        if (node.match(/^<?\w[^>]*[^/]$/)) {
          indent += tab
        }
      })

      return formatted.substring(1, formatted.length - 3)
    },

    downloadXml () {
      if (!this.xmlContent) {
        return
      }

      try {
        const blob = new Blob([this.xmlContent], { type: 'application/xml' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${this.documentName}.xml`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Error downloading XML:', error)
        this.$emit('error', 'Greška pri preuzimanju XML-a')
      }
    }
  }
}
</script>

<style scoped>
.v-dialog__content >>> .my-custom-dialog {
  position: absolute;
  top: 30px;
  border-radius: 25px !important;
}

.xml-content {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  font-family: "Courier New", Courier, monospace;
  font-size: 12px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #333;
  overflow-x: auto;
}

.xml-content::selection {
  background-color: #b3d4fc;
}
</style>
